export const getHash = (fontFamily: string, fontWeight?: string | null, fontStyle?: string): string =>
  `${fontFamily}:${fontWeight ?? ''}:${fontStyle ?? ''}`;

export const parseHash = (hash: string): string[] =>
  hash.split(':');

export const getNormalizedMainFontFamily = (fontFamily: string): string => {
  return fontFamily.split(',')[0].trim().replace(/['"]/g, '');
};

export const getNormalizedFontFamilies = (fontFamily: string): string[] => {
  return fontFamily.split(',').map(s => s.trim().replace(/['"]/g, ''));
};
